export default {
  site_name: 'j9官方平台',
  site_tagline: '备受用户信赖的综合娱乐平台',
  nav_home: '首页',
  nav_category: '游戏分类',
  nav_promotion: '优惠活动',
  nav_about: '关于我们',
  nav_articles: '平台资讯',
  footer_copyright: '© 2026 j9官方平台 版权所有',
  footer_disclaimer: '娱乐有风险，请理性参与。本平台仅供成年人使用。',
  read_more: '了解更多',
  view_all: '查看全部',
  contact_us: '联系我们',
  breadcrumb_home: '首页',
};